// src/data/categories.js
// Catégories d'annonces - NE PAS MODIFIER

export const CATEGORIES = [
    {
      id: 'sejours',
      nameKey: 'categories.sejours',
      icon: '🏨',
      color: '#4299E1',
      description: 'Courte durée - hôtels, studios meublés, chambres',
      priceType: 'perNight', // prix par nuit
    },
    {
      id: 'locations',
      nameKey: 'categories.locations',
      icon: '🏠',
      color: '#48BB78',
      description: 'Longue durée - appartements, maisons à louer mensuellement',
      priceType: 'perMonth', // prix par mois
    },
    {
      id: 'immobilier',
      nameKey: 'categories.immobilier',
      icon: '🌍',
      description: 'Terrains et propriétés à vendre',
      priceType: 'perSquareMeter', // prix au m²
    },
    {
      id: 'services',
      nameKey: 'categories.services',
      icon: '🛎️',
      color: '#ED8936',
      description: 'Services - nettoyage, déménagement, rénovation, sécurité',
      priceType: 'service', // prix forfaitaire ou à négocier
    },
  ];
  
  // Index par ID pour recherche rapide
  export const CATEGORIES_MAP = CATEGORIES.reduce((acc, cat) => {
    acc[cat.id] = cat;
    return acc;
  }, {});
  
  // Fonction pour obtenir une catégorie par ID
  export const getCategoryById = (id) => CATEGORIES_MAP[id];
  
  // Fonction pour obtenir le type de prix d'une catégorie
  export const getCategoryPriceType = (categoryId) => {
    const category = getCategoryById(categoryId);
    return category ? category.priceType : 'custom';
  };
  
  // Icônes pour chaque catégorie
  export const CATEGORY_ICONS = {
    sejours: '🏨',
    locations: '🏠',
    immobilier: '🌍',
    services: '🛎️',
  };
  
  // Couleurs pour chaque catégorie
  export const CATEGORY_COLORS = {
    sejours: '#4299E1',
    locations: '#48BB78',
    immobilier: '#FFD700',
    services: '#ED8936',
  };